/** How many have answered: the one fact that decides "close now, or wait ten more seconds"
 * (UX §8.1). Not a chart — a fraction the size of a headline, and a bar under it.
 *
 * When everyone has answered the fill turns green **and the words change**: colour never
 * carries a state on its own here (WCAG 1.4.1), and the primary button says so too.
 */
import { useTranslation } from "react-i18next";

type Props = { answered: number; present: number };

export function AnsweringMeter({ answered, present }: Props) {
  const { t } = useTranslation();
  const complete = present > 0 && answered >= present;
  const pct = present > 0 ? Math.min(100, Math.round((100 * answered) / present)) : 0;
  return (
    <div className="flex flex-col gap-3">
      <p className="bignum live-count num" style={{ color: complete ? "var(--secure)" : "var(--ink)" }}>
        {answered}/{present}
      </p>
      <p className="text-sm text-[color:var(--ink-2)]">
        {complete ? t("live.stage.everyone") : answered === 0 ? t("live.stage.nobodyYet") : t("live.answeredWord")}
      </p>
      <div
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={present}
        aria-valuenow={answered}
        aria-label={t("live.answered", { a: answered, p: present })}
        className="h-2 w-full overflow-hidden rounded-full bg-[color:var(--surface-2)]"
      >
        <div
          className="h-full rounded-full transition-[width] duration-250 ease-out motion-reduce:transition-none"
          style={{ width: `${pct}%`, background: complete ? "var(--secure)" : "var(--accent)" }}
        />
      </div>
    </div>
  );
}
